// What goes inside each QR code: only a random secret, never seat counts. The counter looks the counts up
// at scan time, so a QR can't be edited, never goes out of date, and stops working when it is reissued.
export const qrValue = {
  /** Family pass: every meal the flat has booked, including bookings made later. */
  flat: (passToken: string) => `one10:flat:${passToken}`,
  /** Meal pass: one meal, every seat of the flat. */
  meal: (passId: string) => `one10:pass:${passId}`,
  /** Single-seat pass: one seat of one meal, for a guest. */
  seat: (seatId: string) => `one10:seat:${seatId}`,
};

/** The scanned text if it is one of our QR codes, else null. */
export function parseQr(raw: string): string | null {
  const v = raw.trim();
  return /^one10:(flat|pass|seat):[A-Za-z0-9_-]{16,40}$/.test(v) ? v : null;
}
